module.exports = __webpack_public_path__ + "img/attention-1.0fcb347a.jpg";